import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Menggunakan relative path untuk menghindari CORS Error di proxy Nginx
      const res = await axios.post('/api/login', { username, password });
      
      const { token, role, guruId, siswaId, nama } = res.data; 

      const namaUserNyata = nama || 'Admin/Staff';

      // Simpan data identitas login secara persisten ke localStorage browser
      localStorage.setItem('token', token);
      localStorage.setItem('role', role);
      if (guruId) localStorage.setItem('guruId', guruId);
      if (siswaId) localStorage.setItem('siswaId', siswaId);
      localStorage.setItem('nama', namaUserNyata);

      Swal.fire({
        icon: 'success',
        title: 'Login Berhasil!',
        text: `Selamat datang, ${namaUserNyata}`,
        timer: 1500,
        showConfirmButton: false
      });

      // Sinkronisasi penuh ke App.js (Token, Role, Nama Pengguna Asli)
      onLogin(token, role, namaUserNyata);

    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Login Gagal',
        text: err.response?.data?.message || 'Periksa koneksi server',
      });
    }
    setLoading(false);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f1f5f9' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '15px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', width: '100%', maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center', color: '#334155', marginBottom: '25px' }}>🔐 Login Sistem</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#64748b' }}>Username / NIS / NIP</label>
            <input 
              type="text" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              placeholder="Masukkan Username" 
              required 
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px' }}
            />
          </div>
          <div style={{ marginBottom: '25px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#64748b' }}>Password</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              placeholder="Masukkan Password" 
              required 
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px' }}
            />
          </div>
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', transition: '0.3s' }}>
            {loading ? 'Memproses...' : 'Masuk Sekarang 🚀'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: '#94a3b8' }}>
          &copy; 2026 SMAN 10 Fajar Harapan
        </p>
      </div>
    </div>
  );
};

export default Login;